import apiClient from '../../services/apiClient';

/** Validate login form fields. Returns error message or null. */
export function validateLoginForm(username: string, password: string): string | null {
  if (!username.trim()) return '請輸入帳號';
  if (!password) return '請輸入密碼';
  return null;
}

/** Validate initial password setup. Returns error message or null. */
export function validateInitialPassword(newPwd: string, confirmPwd: string): string | null {
  if (newPwd.length < 6) return '密碼至少 6 碼';
  if (newPwd !== confirmPwd) return '兩次密碼不一致';
  return null;
}

/** Set initial password for first-time login (no old password required). */
export async function setInitialPassword(newPassword: string): Promise<void> {
  await apiClient.post('/api/v1/auth/initial-password', { newPassword });
}
